import { useAtom } from '@xstate/store/react';

import {
	appendTextPreview,
	clearTextPreview,
	closeHer,
	herState,
	openHer,
	setAnimating,
	setExpanded,
	toggleHer,
} from '../state/HerState';

export const useHerStore = () => {
	const state = useAtom(herState);

	return {
		// State
		isHerActive: state.isHerActive,
		isExpanded: state.isExpanded,
		isAnimating: state.isAnimating,
		contentId: state.contentId,
		cloudID: state.cloudID,
		textPreview: state.textPreview,

		// Actions
		toggleHer,
		openHer,
		closeHer,
		setExpanded,
		setAnimating,
		appendTextPreview,
		clearTextPreview,
	};
};
